export default __webpack_public_path__ + "static/media/lyubo_l.dedca96e.jpg";